import { useNavigate, useLocation, useParams } from "react-router-dom";
import { Typography } from "@mui/material";
import ScreenLoader from "../components/Common/ScreenLoader/ScreenLoader";
import NotificationForm from "../components/inAppNotificationManagement/NotificationForm";
import NotificationPageLayout from "../components/inAppNotificationManagement/NotificationPageLayout";
import { useNotificationDetail } from "../components/inAppNotificationManagement/useNotificationDetail";
import { withNotificationPageAuth } from "../components/inAppNotificationManagement/notificationPageAuth";
import customConfig from "../config";
import {
  buildNotificationListRouteState,
  IN_APP_NOTIFICATION_ROUTES,
} from "../constants/inAppNotificationConstant";

const ViewNotificationPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { notificationId } = useParams();
  const { notification, loading, loadError } = useNotificationDetail(notificationId, {
    fallbackTargetUserCount: location.state?.targetUserCount,
  });

  const navigateBack = () => {
    const listState = location.state?.listState;
    const targetType =
      notification?.targetType || listState?.targetType || "broadcast";

    navigate(IN_APP_NOTIFICATION_ROUTES.list, {
      state: buildNotificationListRouteState({
        targetType,
        listState,
        restoreListPagination: Boolean(listState),
      }),
    });
  };

  if (loading) {
    return (
      <NotificationPageLayout
        breadcrumbLabel="View Notification"
        title="View Notification"
        subtitle="Review notification details and configuration."
        restoreListPaginationOnBack
      >
        <ScreenLoader message={customConfig.FETCHING_DATA} />
      </NotificationPageLayout>
    );
  }

  if (loadError || !notification) {
    return (
      <NotificationPageLayout
        breadcrumbLabel="View Notification"
        title="View Notification"
        subtitle="Review notification details and configuration."
        restoreListPaginationOnBack
      >
        <Typography color="error">{loadError || customConfig.FETCH_FAILURE}</Typography>
      </NotificationPageLayout>
    );
  }

  return (
    <NotificationPageLayout
      breadcrumbLabel="View Notification"
      title="View Notification"
      subtitle="Review notification details and configuration."
      restoreListPaginationOnBack
    >
      <NotificationForm
        mode="view"
        initialData={notification}
        defaultTargetType={notification.targetType}
        fallbackTargetUserCount={location.state?.targetUserCount}
        onCancel={navigateBack}
      />
    </NotificationPageLayout>
  );
};

export default withNotificationPageAuth(ViewNotificationPage);
